// extracted by mini-css-extract-plugin
export default {"coin":"EkXXw1AStajqWvCuNBuC","noColors":"xhRdvXODmDyMrdibKEvP","icon":"Gzf7HcQ6VyVu5j2kRBIQ","letter":"YliQBxz86d7nfsgxoAAH"};